import styles from "./StatusBadge.module.css";

// Helper: sanitizes raw status string to readable Title Case
const sanitizeStatusText = (val) => {
  if (!val) return "Unknown";
  return String(val)
    .replace(/[_-]+/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const STATUS_VARIANT_MAP = {
  // Stage 1: Waiting / Pending (Yellow -> "warning")
  SUBMITTED: "warning",
  AWAITING_HOST: "warning",
  PENDING_HOST_APPROVAL: "warning",
  PENDING: "warning",
  WAITING: "warning",
  HELD_AT_GATE: "warning",
  ESCALATED_DELEGATE: "warning",

  // Stage 2: Approved / Routed / Assigned (Blue -> "info" / "primary")
  ASSIGNED: "info",
  ROUTED: "info",
  APPROVED: "info",
  ESCALATED_RECEPTION: "primary",
  OPEN: "info",

  // Stage 3: Checked In / Active (Green -> "success")
  CHECKED_IN: "success",
  INSIDE: "success",
  IN_PREMISES: "success",
  ACTIVE: "success",
  RESOLVED: "success",

  // Stage 4: Checked Out / Closed (Grey -> "neutral")
  COLLECTED: "neutral",
  CHECKED_OUT: "neutral",
  AUTO_CHECKED_OUT: "neutral",
  INACTIVE: "neutral",
  CLOSED: "neutral",
  COMPLETED: "neutral",

  // Terminated / Danger (Red -> "danger")
  REJECTED: "danger",
  EXPIRED: "danger",
  CANCELLED: "danger",
  REVOKED: "danger",
  SUSPENDED: "danger",
};

const STATUS_LABEL_MAP = {
  SUBMITTED: "Submitted",
  AWAITING_HOST: "Awaiting Approval",
  PENDING_HOST_APPROVAL: "Awaiting Approval",
  PENDING: "Pending",
  WAITING: "Waiting",
  HELD_AT_GATE: "Held at Gate",
  ESCALATED_DELEGATE: "Escalated (Delegate)",
  ESCALATED_RECEPTION: "Escalated (Reception)",
  ASSIGNED: "Assigned",
  ROUTED: "Routed",
  APPROVED: "Approved",
  CHECKED_IN: "Checked In",
  INSIDE: "Inside Premises",
  IN_PREMISES: "Inside Premises",
  COLLECTED: "Collected at Gate",
  CHECKED_OUT: "Checked Out",
  AUTO_CHECKED_OUT: "Auto Checked Out",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  CANCELLED: "Cancelled",
  REVOKED: "Revoked",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  CLOSED: "Closed",
  RESOLVED: "Resolved",
  OPEN: "Open",
};

const StatusBadge = ({
  status,
  variant,
  label,
  showDot = true,
  className = "",
}) => {
  const normalizedKey = status
    ? String(status).trim().toUpperCase().replace(/\s+/g, "_")
    : "";
  const resolvedVariant =
    variant || STATUS_VARIANT_MAP[normalizedKey] || "neutral";
  const resolvedLabel =
    label ||
    STATUS_LABEL_MAP[normalizedKey] ||
    (status ? sanitizeStatusText(status) : "Unknown");

  return (
    <span
      className={`${styles.badge} ${
        styles[resolvedVariant] || styles.neutral
      } ${className}`.trim()}
    >
      {showDot && <span className={styles.dot} aria-hidden="true" />}
      <span>{resolvedLabel}</span>
    </span>
  );
};

export default StatusBadge;
